import React from 'react';
import PropTypes from 'prop-types';
import OperatorInfo from './OperatorInfo';
import FormInput from '../../../commonComponents/forms/FormInput';
import UserProp from '../../../commonComponents/propTypes/userProp';
import UserTypeNamesProp from '../../../commonComponents/propTypes/userTypeNamesProp';
import translate from '../../../commonComponents/translate';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';

function OperatorSection(props) {
  const {
    t,
    handleOperatorChange,
    operator,
    userTypeNames,
    setOperatorAddress,
    handleAddOperatorAddress,
    handleAddressOpen,
    languages,
  } = props;
  return (
    <div
      className="m-portlet m-portlet--mobile col-lg-12 col-12"
      id="operatorContainer"
    >
      <div className="m-portlet__body operator-section">
        <h4 className="order-card-title">{t('order_operator')}</h4>
        <p className="order-operator-description">
          {t('order.operator.description')}
        </p>
        <FormInput
          type="users"
          id="operators"
          name="operators"
          labelClassName="col-lg-2 col-12 label-customer text-right"
          containerClassName="col-lg-8 col-12 row no-gutters customer-info-correct-mobile"
          label={t('order_operator')}
          placeholder={t('order_operator_placeholder')}
          groupProps={{
            className:
              'row col-12 order-create-content order-create-content-seller',
          }}
          onChange={handleOperatorChange}
          value={operator?._id}
          width="100%"
          className="form-control m-input"
          inputProps={{
            showFilter: true,
            multiple: false,
            userTypeNames,
            allowClear: false,
            url: '/user/table/list?isOperator=true',
            languages,
          }}
        />
      </div>
      {operator?._id && (
        <div className="customer-info justify-content-center">
          <OperatorInfo
            onShippingChange={setOperatorAddress}
            onAddShipping={handleAddOperatorAddress}
            user={operator}
            onAddressOpen={handleAddressOpen}
          />
        </div>
      )}
    </div>
  );
}

OperatorSection.propTypes = {
  t: PropTypes.func.isRequired,
  handleOperatorChange: PropTypes.func.isRequired,
  operator: PropTypes.shape(UserProp.propType),
  userTypeNames: PropTypes.shape(UserTypeNamesProp.propType).isRequired,
  setOperatorAddress: PropTypes.func.isRequired,
  handleAddOperatorAddress: PropTypes.func.isRequired,
  handleAddressOpen: PropTypes.func.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
};
OperatorSection.defaultProps = {
  operator: null,
};

export default translate(OperatorSection);
